module.exports = {
  "scaleTypeTemplate": {
    "scaleTypeTemplate": "量表分类",
    "scaleTypeTemplateHint": "请输入分类名称",
    "editScaleTypeTemplate": "编辑量表分类模板",
    "addScaleTypeTemplate": "新增量表分类模板",
    "classifyName": "分类名称",
    "fatherClassify": "上级分类",
    "fatherClassifyHint": "请选择上级分类",
    "classifyDetails": "分类描述",
    "classifyDetailsHint": "请输入分类描述",
    "viewSort": "显示序号",
    "viewSortHint": "请输入显示序号",
    "deleteClassifyHint": "被删除的量表分类将不可恢复，确定吗",
    "addClassifyHint": "请在右侧输入要新增的量表分类信息，然后点击保存",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/scaleTypeTemplate/zh-CN.js